enum PhysicalExaminationStatusEnum {
  Unknown = 0,
  ReadyForEvaluation = 1,
  DocumentApproved = 2,
  DocumentRejected = 3,
}

export default PhysicalExaminationStatusEnum;
